import "./PrivateLabelProductSupport.module.css";
import Header from "@/reusable_sections/Header";
import Overview from "./sections/Overview";
import OurPrivateLabelServices from "./sections/OurPrivateLabelServices";
import ExpertTeam from "./sections/ExpertTeam";
import ContactAndConsultation from "./sections/ContactAndConsultation";
import Footer from "@/reusable_sections/Footer";
export default function PrivateLabelProductSupportPage() {
  return <div>
      <Header />
      <Overview />
      <OurPrivateLabelServices />
      <ExpertTeam />
      <ContactAndConsultation />
      <Footer />
    </div>;
}